/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Vat_NumberInputs */

const en_reference_field_vat_number = /** @type {(inputs: Reference_Field_Vat_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT number`)
};

/**
* | output |
* | --- |
* | "VAT number" |
*
* @param {Reference_Field_Vat_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_vat_number = /** @type {((inputs?: Reference_Field_Vat_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Vat_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_vat_number(inputs)
});